import { CustomeTripQuestion } from "./custom-question.model";
import { BasePermissionModel } from "../../shared/models/base-permission-model";

export class PrePostTripQuestionModel {
  companyHashId: string = "";
  vehicleHashId: string = "";
  svgHashId: string = "";
  public instanceName: string;
  public companyName: string;
  public sharedVehicleGroupName: string;
  public vehicleName: string;
  public isEditable: boolean;
  prePostQuestionHashId: string;
  instanceHashId: string = "";
  isDeletable: boolean;
  basePermissionModel: BasePermissionModel;
  isAdd: boolean;
  isInsert:boolean;
  isInstance:boolean;
  public isChecked: boolean;
  questionType: string = "";

  public customeTripQuestion: Array<CustomeTripQuestion>;

  constructor() {
    this.customeTripQuestion = Array<CustomeTripQuestion>();
    this.basePermissionModel = new BasePermissionModel();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question/models/pre-post-trip-question.model.ts